import type { BasePublicationStatus } from "@/types/base";

export function shouldShowBaseAds(input: {
  ads_enabled: boolean;
  publication_status: BasePublicationStatus;
}): boolean {
  if (!input.ads_enabled) return false;
  if (input.publication_status !== "published") return false;

  return true;
}

export function shouldShowCategoryPageAds(
  page: { ads_enabled: boolean } | null | undefined
): boolean {
  if (!page) return false;

  return page.ads_enabled;
}

export function shouldShowLevelAds(
  level: { ads_enabled: boolean } | null | undefined
): boolean {
  if (!level) return false;

  return level.ads_enabled;
}

export function shouldShowNewsAds(
  article: { ads_enabled: boolean } | null | undefined
): boolean {
  if (!article) return false;

  return article.ads_enabled;
}
